import { render, staticRenderFns } from "./MerchantPage.vue?vue&type=template&id=778f288c&scoped=true&"
import script from "./MerchantPage.vue?vue&type=script&lang=js&"
export * from "./MerchantPage.vue?vue&type=script&lang=js&"
import style0 from "./MerchantPage.vue?vue&type=style&index=0&id=778f288c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f288c",
  null
  
)

export default component.exports